import CookieHelper from "../helpers/cookie-helper";


class User {

    
    constructor() {
        this._username;
        this._password;
    }

    /**
     * Username getter. 
     *
     * @returns string
     */
    get username() {
        return this._username;
    }

    /**
     * Username setter.
     * 
     * @param username: string
     * @returns void
     */
    set username(username) {
        this._username = username;
    }


    /**
     * Password getter.
     * 
     * @returns string
     */
    get password() {
        return this._password;
    }

    /**
     * Password setter.
     * 
     * @returns void
     */
    set password(password) {
        this._password = password;
    }

    /**
     * Checks is user logged in.
     * 
     * @returns boolean
     */
    isLogggedIn() {

        if (CookieHelper.get('uName') !== undefined && CookieHelper.get('uName') != '' && CookieHelper.get('uName') != null && CookieHelper.get('token') != '' && CookieHelper.get('token') != null && CookieHelper.get('token') !== undefined) {
            return true;
        }
        
        return false;
    }



}

export default User;



//////////////////
// WEBPACK FOOTER
// ./src/games/horse-racing/js/user/user.js
// module id = 158
// module chunks = 7